module.exports = __webpack_public_path__ + "static/media/about-woman-img.4a9bdfc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about-woman-img.jpg
// module id = 111
// module chunks = 0